<template>
  <div  class="container">
    <el-form :inline="true" ref="search" :model="search" class="demo-form-inline">
      <el-form-item prop="rangeDate">
        <el-date-picker
          v-model="search.rangeDate"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="hospital">
        <el-select v-model="search.hospital" allow-create filterable default-first-option placeholder="医院">
          <el-option
            v-for="hospital in hospitalColumns"
            :label="hospital"
            :value="hospital"
            :key="hospital"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="name">
        <el-input v-model="search.name" placeholder="服务对象姓名"></el-input>
      </el-form-item>
      <el-form-item prop="nurse">
        <el-input v-model="search.nurse" placeholder="护理员姓名"></el-input>
      </el-form-item>
      <el-form-item prop="area">
        <el-select v-model="search.area" placeholder="乡镇">
          <el-option v-for="area in villagesColumns" :label="area" :value="area" :key="area"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="status">
        <el-select v-model="search.status" placeholder="住院状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="住院中" value="1"></el-option>
          <el-option label="已出院" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchData">查询</el-button>
        <el-button @click="resetForm('search')">重置</el-button>
        <el-button type="primary" @click="exportExcel">导出</el-button>
      </el-form-item>
    </el-form>
    <div class="total">共 {{ total }} 条数据</div>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      max-height="600"
      stripe
    >
      <el-table-column prop="enter" label="入院日期" minWidth="120"> </el-table-column>
      <el-table-column prop="name" label="服务对象姓名" minWidth="120"> </el-table-column>
      <el-table-column prop="area" label="乡镇" minWidth="120"> </el-table-column>
      <el-table-column prop="hospital" label="所在医院" minWidth="150"> </el-table-column>
      <el-table-column label="住院状态" minWidth="120">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.status"
            placeholder="住院状态"
            @change="changeStatus(scope.row.id, $event)"
          >
            <el-option label="住院中" :value="1"></el-option>
            <el-option label="已出院" :value="2"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column minWidth="180" label="出院时间"
        >]
        <template slot-scope="scope">
          {{ scope.row.status === 2 ? scope.row.leave : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="nurse" label="护理员姓名" width="120"> </el-table-column>
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <i class="el-icon-tickets fz24" @click="handleDetails(scope.row.id)" title="详情"></i>
          <i class="el-icon-delete fz24 ml"  v-if="isAdmin" @click="handleDelete(scope.row.id)" title="删除"></i>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :current-page="pageNumber"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { serviceList, serviceEdit, exportExcel1, serviceDel } from '@/api'
import { isAdmin } from '../utils/util'
export default {
  data() {
    const isDate = new Date()
    return {
      disabled: false,
      isAddNurse: false,
      fileList: [],
      thisDate: Date.parse(`${isDate.getFullYear()}/${isDate.getMonth() + 1}/${isDate.getDate()} 00:00:00`),
      search: {
        rangeDate: [],
        startDate: '',
        endDate: '',
        hospital: '',
        name: '',
        nurse: '',
        area: '', // 乡镇
        status: '1'
      },
      tableLoading: false,
      pageSize: 10,
      pageNumber: 1,
      total: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      villagesColumns: [
        '全部',
        '经开区',
        '梅城镇',
        '王河镇',
        '源潭镇',
        '余井镇',
        '黄泥镇',
        '槎水镇',
        '官庄镇',
        '水吼镇',
        '黄柏镇',
        '黄铺镇',
        '天柱山镇',
        '油坝乡',
        '痘姆乡',
        '塔畈乡',
        '五庙乡',
        '龙潭乡'
      ],
      hospitalColumns: [
        '全部',
        '潜山市立医院',
        '潜山市中医院',
        '梅城镇卫生院',
        '王河镇卫生院',
        '源潭镇卫生院',
        '余井镇卫生院',
        '黄泥镇卫生院',
        '槎水镇卫生院',
        '官庄镇卫生院',
        '水吼镇卫生院',
        '黄柏镇卫生院',
        '黄铺镇卫生院',
        '天柱山镇卫生院',
        '油坝乡卫生院',
        '痘姆乡卫生院',
        '塔畈乡卫生院',
        '五庙乡卫生院',
        '龙潭乡卫生院',
        '潜山同和医院',
        '潜山同春医院',
        '潜山东华医院',
        '潜山朝阳医院',
        '安庆市立医院',
        '合肥四院'
      ],
      tableData: [],
      dialogVisible: false,
      imgUrl: '',
      editVisible: false,
      editForm: {
        id: '',
        nurse: '',
        inServicePicture: '',
        brokerage: '',
        selfcareAbility: '',
        modificationTime: `${isDate.getFullYear()}/${isDate.getMonth() + 1}/${isDate.getDate()} ${isDate.getHours()}:${isDate.getMinutes()}`,
        nurse_tel: ''
      },
      editFormTitle: '',
      formLabelWidth: '153px'
    }
  },
  computed: {
    isAdmin() {
      return isAdmin()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.pageNumber = 1
      this.getList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.pageNumber = val
      this.getList()
    },
    searchData() {
      this.pageNumber = 1
      this.getList()
    },
    getList() {
      this.tableLoading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        ...this.search
      }
      params.hospital = params.hospital === '全部' ? '' : params.hospital
      params.area = params.area === '全部' ? '' : params.area
      params.startDate = params.rangeDate[0]
      params.endDate = params.rangeDate[1]
      delete params.rangeDate
      this.tableLoading = true
      serviceList(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    exportExcel() {
      exportExcel1()
        .then(res => {
          if (res.data) {
            const elink = document.createElement('a') // 创建a标签用于文件下载
            elink.href = res.data // 赋值下载路径
            elink.download = '数据表格.xlsx' // 下载的文件名称（非必填）
            document.body.appendChild(elink) // 插入DOM树
            elink.click() // 点击a标签触发
            document.body.removeChild(elink) // 删除a标签
          } else {
            this.$message.warning('没有数据可以导出')
          }
        })
        .catch(() => {
          this.$message.error('下载失败')
        })
    },
    changeStatus(id, status) {
      const params = {
        id,
        status
      }
      serviceEdit(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleDelete(id) {
      this.$confirm(`确定删除吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          serviceDel({
            id
          }).then(res => {
            if (res.status) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    handleDetails(_RowId) {
      this.$router.push('/details?id=' + _RowId)
    }
  }
}
</script>

<style lang="scss">
.el-upload--picture-card{
  width: 124px !important;
  height: 124px !important;
  line-height: 124px !important;
}
.el-upload-list--picture-card .el-upload-list__item{
  width: 124px !important;
  height: 124px !important;
}
</style>
<style lang="scss" scoped>
.tipsBox{ color: red; float: right;margin-top: -25px}
.servicePictureBox{ width: 100px; height: 100px}
.updatedAt {
  text-align: center;
}
.container {
  width: 100%;
  .imgbox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .litimg {
      width: 30px;
      height: 30px;
      margin: 3px;
      object-fit: cover;
      cursor: zoom-in;
    }
  }

  .picture {
    width: 100%;
  }
  .block {
    text-align: center;
  }
  .el-pagination {
    margin-top: 20px;
  }
  .total {
    padding: 0 6% 15px;
    color: #26A4B2;
    text-align: right;
    font-weight: bold;
  }
}
</style>
